<div class="d-flex flex-column gap-1">
  @if (textContent() || showCursor()) {
  <div class="ai-bubble d-flex flex-column gap-2">
    @if (textContent()) {
    <app-markdown-renderer [content]="textContent()" />
    }
    @if (showCursor()) {
    <span class="chat-cursor ms-1"></span>
    }
  </div>
  }

  @if (debugMode.isDebugMode() && toolCalls().length > 0) {
  <div class="d-flex flex-wrap gap-2">
    @for (tc of toolCalls(); track tc.id) {
      <app-tool-call-hint [toolCall]="tc" />
    }
  </div>
  }

  <app-content-dispatcher [messageId]="message()?.id ?? ''" />

  <span class="mat-font-label-sm px-1 mat-text-on-surface-variant">
    {{ timestamp() | date: "HH:mm" }}
  </span>
</div>
